export enum ExportTypes {
    PDF = 'PDF',
    CSV = 'CSV',
    XLSX = 'XLSX'
}